import type { ComponentPropsWithRef } from 'react'
import { LuxPlusPartnerPromoClassifier, type LuxPlusPartnerPromoClassifierType } from 'luxPlus/constants/partnerPromo'

import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineUnlockAltIcon from 'LuxKit/Icons/line/LineUnlockAltIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineLockAltIcon from 'LuxKit/Icons/line/LineLockAltIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineFullAppleIcon from 'LuxKit/Icons/line/LineFullAppleIcon'
import LineTagIcon from 'LuxKit/Icons/line/LineTagIcon'
import LineWineBottleIcon from 'LuxKit/Icons/line/LineWineBottleIcon'

export const SUPPORTED_BENEFITS_ICONS: Record<App.LuxPlusBenefitType, typeof SvgIcon> = {
  discounted_flash: LineBedIcon,
  hotel_inclusions: LineStarIcon,
  exclusive_offers: LineLockAltIcon,
  priority_support: LinePhoneIcon,
  discounted_tours: LineCompassIcon,
  early_access: LineUnlockAltIcon,
  discounted_insurance: LineShieldCheckIcon,
  cruise_inclusions: LineShipIcon,
  discounted_experiences: LineRestaurantIcon,
  partner_promo_code: LineCarIcon,
  promo: LineTagIcon,
  voucher: LineTagIcon,
}

export const PARTNER_PROMO_CODE_ICONS: Record<LuxPlusPartnerPromoClassifierType, typeof SvgIcon> = {
  [LuxPlusPartnerPromoClassifier.HELLOFRESH]: LineFullAppleIcon,
  [LuxPlusPartnerPromoClassifier.TURO]: LineCarIcon,
  [LuxPlusPartnerPromoClassifier.WINE_SELECTORS]: LineWineBottleIcon,
}

interface Props extends ComponentPropsWithRef<typeof SvgIcon> {
  benefit: App.OfferSubscriptionBenefitItem | App.MemberSubscriptionBenefitItem
}

export default function LuxPlusBenefitIcon({ benefit, ...rest }: Props) {
  const Icon = SUPPORTED_BENEFITS_ICONS[benefit.type]
  if (benefit.classifier) {
    const PartnerPromoIcon = PARTNER_PROMO_CODE_ICONS[benefit.classifier]
    if (PartnerPromoIcon) {
      return <PartnerPromoIcon {...rest} />
    }
  }
  return <Icon {...rest} />
}
